export default __webpack_public_path__ + "static/media/Doggy_fly-min.48c6ebe8.png";